<template>
    <custom-table
        :title="$t('pages.company.specialty.title')"
        :subTitle="$t('pages.company.specialty.subTitle')"
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        changeUrlPage
        @action="handleClickAction"
        @changeTable="handleTableChange"
    >
        <template v-slot:name="{ row: record }">
            {{ record.name }}
        </template>
        <template v-slot:companies_count="{ row: record }">
            {{ record.companies_count }}
        </template>
    </custom-table>
</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "specialty",
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("pages.company.cols.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.company.specialty.cols.name"),
                    scopedSlots: {customRender: "name"}
                },
                {
                    name: this.$t("pages.company.specialty.cols.companiesCount"),
                    scopedSlots: {customRender: "companies_count"}
                }
            ],
            actions: [
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                }

            ],
        }
    },
    created() {
    },
    computed: {
        table() {
            return this.$store.state.company.specialty.table;
        }
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("menu.companySpecialty"), []);

        this.filterParameters = {
            sort: 'created_at:desc'
        };

        this.$store.dispatch('company/specialty/get', {
            page: {
                current: this.$route.query.page
            },
            filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
        });
    },
    methods: {
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                default:
                    break;
            }
        },
        refreshTable() {
            this.$store.dispatch('company/specialty/get', {
                page: {
                    current: this.$route.query.page
                },
                filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
            });
        },
        handleTableChange(pagination, filterData) {
            this.filterParameters = Object.assign({
                sort: 'created_at:desc',
            }, filterData);

            this.$store.dispatch("company/specialty/get", {
                page: pagination,
                filterData: this.filterParameters
            });
        },
        handleSelectedRow(record) {
            this.selectedRowKeys = record;
        }
    }
}
</script>

<style scoped>

</style>